'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var TopChartController = (function () {
    function TopChartController($scope, $rootScope, $routeParams, BPChartService, YoutubeSDKService, YoutubeService) {
        var _this = this;

        _classCallCheck(this, TopChartController);

        this.$scope = $scope;
        this.$scope.idx = 0;
        this.$rootScope = $rootScope;
        this.$scope.category = $routeParams.category || 'psy-trance';
        this.BPChartService = BPChartService;
        this.YoutubeSDKService = YoutubeSDKService;
        this.YoutubeService = YoutubeService;

        this.YoutubeSDKService.onPlayerStateChange = function (event) {
            switch (event.data) {
                case YT.PlayerState.ENDED:
                    $rootScope.$broadcast('play:next');

                    break;

                default:
                    console.log(event.data);
                    $rootScope.$broadcast('player:state', event.data);
                    break;
            }
        };

        $rootScope.$on('play:next', function () {
            _this.$scope.playTrack(_this.$scope.idx + 1);
        });

        $rootScope.$on('play:play', function () {
            _this.$scope.playTrack(_this.$scope.idx);
        });

        $rootScope.$on('play:pause', function () {
            _this.YoutubeSDKService.stopVideo();
            $rootScope.$broadcast('player:state', YT.PlayerState.PAUSED);
        });

        $rootScope.$on('play:previous', function () {
            _this.$scope.playTrack(_this.$scope.idx - 1);
        });

        $rootScope.pageTitle = 'Top 100 ' + this.$scope.category.replace('-', ' ') + ' Tracks';

        // settings
        $scope.settings = {
            singular: 'Track',
            plural: 'Tracks',
            cmd: 'Play'
        };

        this.initTracks();

        $scope.checkAll = function () {
            _angular2['default'].forEach($scope.tracks, function (track) {
                track.selected = !track.selected;
            });
        };

        $scope.playTrack = function (idx) {
            return _this.play(idx);
        };

        $scope.$on('$destroy', function () {
            _this.$scope.idx = 0;
            //this.hideForm();
        });
    }

    /**
     *
     */

    _createClass(TopChartController, [{
        key: 'play',
        value: function play(idx) {
            var _this2 = this;

            this.$scope.idx = idx;

            var track = this.getTrackByIndex(idx);

            if (track) {
                this.YoutubeService.search(track.artist + ' - ' + track.title).then(function (videoID) {
                    if (null === videoID) return;

                    track.playing = true;
                    _this2.$scope.track = track;
                    _this2.$scope.settings.cmd = 'Playing';

                    _this2.YoutubeSDKService.load(videoID);
                });

                return true;
            }

            console.log(['error, track not found', idx, track]);
        }

        /**
         *
         */
    }, {
        key: 'getTrackByIndex',
        value: function getTrackByIndex(idx) {
            return this.$scope.tracks[idx];
        }

        /**
         *
         */
    }, {
        key: 'getIcon',
        value: function getIcon(name) {
            return '<i class="zmdi zmdi-' + name + '"></i>';
        }

        /**
         *
         */
    }, {
        key: 'initTracks',
        value: function initTracks() {
            var _this3 = this;

            this.BPChartService.getList(this.$scope.category).then(function (tracks) {
                _this3.$scope.tracks = tracks;
            });
        }
    }]);

    return TopChartController;
})();

exports['default'] = TopChartController;

TopChartController.$inject = ['$scope', '$rootScope', '$routeParams', 'BPChartService', 'YoutubeSDKService', 'YoutubeService'];
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./resources/assets/js/src/modules/beatport/controller/top_chart_controller.js
 ** module id = 38
 ** module chunks = 0
 **/